import React, { Component } from 'react';
import { Card, Dropdown, DropdownButton, Row, Col, Button, Pagination } from 'react-bootstrap';

class PaginationC extends Component {
    state = {}
    render() {
        return (
            

            <Pagination style={{ margin: "auto" }} >
                <Pagination.First onClick={() => { this.props.changePage(1) }} />
                <Pagination.Prev onClick={() => { this.props.changePage(this.props.currentPage - 1 > 0 ? this.props.currentPage - 1 : 1) }} />
                {this.props.currentPage > 1 && <Pagination.Item onClick={() => { this.changePage(1) }}>{1}</Pagination.Item>}

                {this.props.currentPage > 3 && <Pagination.Ellipsis />}

                {this.props.currentPage - 2 > 2 && <Pagination.Item onClick={() => { this.props.changePage(this.props.currentPage - 2) }}>{this.props.currentPage - 2}</Pagination.Item>}
                {this.props.currentPage - 1 > 1 && <Pagination.Item onClick={() => { this.props.changePage(this.props.currentPage - 1) }}>{this.props.currentPage - 1}</Pagination.Item>}
                <Pagination.Item active>{this.props.currentPage}</Pagination.Item>
                {this.props.currentPage + 1 < this.props.pages && <Pagination.Item onClick={() => { this.props.changePage(this.props.currentPage + 1) }}>{this.props.currentPage + 1}</Pagination.Item>}
                {this.props.currentPage + 2 < this.props.pages && <Pagination.Item onClick={() => { this.props.changePage(this.props.currentPage + 2) }}>{this.props.currentPage + 2}</Pagination.Item>}

                {this.props.currentPage + 3 < this.props.pages && <Pagination.Ellipsis />}
                {this.props.currentPage < this.props.pages && <Pagination.Item onClick={() => { this.props.changePage(this.props.pages) }}>{this.props.pages}</Pagination.Item>}
                <Pagination.Next onClick={() => { this.props.changePage(this.props.currentPage + 1 <= this.props.pages ? this.props.currentPage + 1 : this.props.pages > 0 ? this.props.pages : 1) }} />
                <Pagination.Last onClick={() => { this.props.changePage(this.props.pages > 0 ? this.props.pages : 1) }} />
            </Pagination>
        );
    }
}

export default PaginationC;